import { UilLocationArrow } from '@iconscout/react-unicons'
import { MapControlButton } from 'components/MapV2/Map.style'
import { useMapContext } from 'components/MapV2/MapProvider'
import React from 'react'
import { useMap } from 'react-leaflet'

export const FitToMarkers: React.FC = () => {
  const { onFitToMarkers } = useMapContext()
  const map = useMap()

  if (!onFitToMarkers) return null

  return (
    <MapControlButton
      data-testid="fit-to-markers"
      size="medium"
      disabled={false}
      variant="outline"
      color="secondary"
      iconLeft={UilLocationArrow}
      onClick={() => onFitToMarkers(map)}
      onlyIcon
    />
  )
}
